<template>
  <form-wizard
    :color="color"
    :title="title"
    :subtitle="subtitle"
    :shape="shape"
    :next-button-text="nextButtonText"
    :back-button-text="backButtonText"
    :finish-button-text="finishButtonText"
    @on-complete="handleComplete"
    ref="wizard"
  >
    <tab-content
      v-for="(step, index) in steps"
      :key="index"
      :title="step.title"
      :before-change="step.beforeChange"
    >
      <component
        v-if="step.component"
        :is="step.component"
        v-bind="step.props || {}"
        v-on="step.events || {}"
      />
    </tab-content>
  </form-wizard>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';

export default {
  name: 'ReusableWizard',
  components: {
    FormWizard,
    TabContent,
  },
  props: {
    steps: { type: Array, required: true },
    onComplete: { type: Function, required: true },
    color: { type: String, default: '#3498db' },
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    shape: { type: String, default: 'square' },
    nextButtonText: { type: String, default: 'Next' },
    backButtonText: { type: String, default: 'Back' },
    finishButtonText: { type: String, default: 'Finish' },
  },
  methods: {
    handleComplete() {
      if (typeof this.onComplete === 'function') {
        this.onComplete();
      } else {
        console.warn('onComplete is not a function');
      }
    },
    reset() {
      this.$refs.wizard?.reset();
    },
  },
};
</script>
